import React from 'react';

import { Box } from '@mui/material';

export default function DealFieldBox({ value }: { value: string }) {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        fontSize: 13,
        overflow: 'hidden',
        px: 1.5,
        py: 0.75,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </Box>
  );
}
